export interface CognitoConfig {
  authority: string; // https://cognito-idp.<region>.amazonaws.com/<userPoolId>
  clientId: string;
  redirectUri: string;
  scope: string;
  identityProvider?: string; // e.g. "IdentityCenter" to skip the IdP chooser
}

export interface RuntimeConfig {
  useFixture: boolean;
  apiUrl: string;
  cognito?: CognitoConfig;
  /**
   * Dev hub EC2 instance id (e.g. "i-0123456789abcdef0"). Set to enable the VPN enrollment page's
   * copy-port-forward command (SSM port forwarding to a gateway with no direct route to the hub).
   * Omitted -> that menu item is hidden.
   */
  /** Fallback only: the BFF returns the current hub id with the VPN peer status. */
  vpnHubInstanceId?: string;
}

// Default: fixture mode (no backend). A deployed build serves /config.json that overrides this.
let current: RuntimeConfig = { useFixture: true, apiUrl: '' };

export function getConfig(): RuntimeConfig {
  return current;
}

/** Load /config.json at startup; fall back to fixture mode if absent. */
export async function initConfig(): Promise<RuntimeConfig> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) {
      const json = (await res.json()) as Partial<RuntimeConfig>;
      current = {
        useFixture: json.useFixture ?? false,
        apiUrl: json.apiUrl ?? '',
        cognito: json.cognito,
        vpnHubInstanceId: json.vpnHubInstanceId,
      };
    }
  } catch {
    /* keep fixture default */
  }
  return current;
}
